(function (factory) {
  const estimator = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = estimator;
  if (typeof document !== 'undefined') estimator.start();
})(function () {
  'use strict';
const {FABRICS,LENGTHS,LAYERS,NETTINGS,ZIPPERS,RIDGELINES,CONTINUOUS_LOOPS,SUSPENSIONS,DELTAS,STUFF_SACKS,REQUIRED_DELTA_FIELDS}=window.SLDEstimatorData.products["trail_lair"];
const CONTROLS=window.SLDEstimatorData.productControls.trailLair;

  const FIELD_LABELS = Object.freeze({
    'Fabric/Color * (required)': 'Fabric/Color',
    'Length * (required)': 'Length',
    "Layers * (required)": 'Layers',
    "Netting Material * (required)": 'Netting Material',
    "Zipper Size * (required)": 'Zipper Size',
    'Ridgeline Material * (required)': 'Ridgeline Material',
    "Suspension * (required)": 'Suspension Type',
    'Continuous Loops * (required)': 'Continuous Loops',
    "Knee & Shoulder Tie Outs * (required)": 'Knee & Shoulder Tie Outs',
    "Under Quilt Hooks * (required)": 'Under Quilt Hooks',
    "Peak Shelf * (required)": 'Peak Shelf',
    'Bivy Mode Tie Outs * (required)': 'Bivy Mode Tie Outs',
    "Ridgeline Gear Pouch * (required)": 'Ridgeline Gear Pouch',
    'Stuff Sack Options * (required)': 'Stuff Sack Options',
    "Zippered Shoulder Pouch * (required)": 'Zippered Storage Pouch'
  });

  

  

  

  

  

  

  

  

  

  

  

  const clean = (value) => String(value || '').replace(/\s+/g, ' ').trim();
  const own = (object, key) => Object.prototype.hasOwnProperty.call(object, key);

  function deltaFor(field, value) {
    return own(DELTAS, field) && own(DELTAS[field], value) ? DELTAS[field][value] : 0;
  }

  function selections(scope) {
    const selected = Object.create(null);
    for (const element of scope.querySelectorAll('select')) {
      const domLabel = clean(element.labels && element.labels[0] && element.labels[0].textContent);
      if (!own(FIELD_LABELS, domLabel)) continue;
      selected[FIELD_LABELS[domLabel]] = clean(element.value);
    }
    return selected;
  }

  function nettingWeight(length, netting, zipper) {
    const area = (netLength) => (netLength - 27) * netting.width - 9;
    return netting.base +
      ((area(length.netLength) - area(netting.baseline)) * netting.density / 1296) +
      (length.tapeLength * zipper.tapeAdjustment);
  }

  function mainSackWeight(fabric, layerCount, zipperValue) {
    if (layerCount > 1 || fabric.wide) return CONTROLS.mainSacks.doubleOrWide;
    if (fabric.lightSack) return zipperValue === '#5 YKK w/ silver pulls' ? CONTROLS.mainSacks.lightFive : CONTROLS.mainSacks.lightThree;
    return CONTROLS.mainSacks.standard;
  }

  function estimate(choice) {
    const fabric = FABRICS[choice['Fabric/Color']];
    const length = LENGTHS[choice.Length];
    const layerCount = LAYERS[choice.Layers];
    const netting = NETTINGS[choice['Netting Material']];
    const zipper = ZIPPERS[choice['Zipper Size']];
    const ridgelineKey = RIDGELINES[choice['Ridgeline Material']];
    const suspension = SUSPENSIONS[choice['Suspension Type']];
    const loopWeight = CONTINUOUS_LOOPS[choice['Continuous Loops']];
    const stuffSackUpgrade = STUFF_SACKS[choice['Stuff Sack Options']];

    const requiredDeltaChoicesValid = REQUIRED_DELTA_FIELDS.every(
      (field) => own(DELTAS[field], choice[field])
    );

    if (!fabric || !length || !layerCount || !netting || !zipper || !ridgelineKey ||
        !suspension || loopWeight === undefined || stuffSackUpgrade === undefined ||
        !requiredDeltaChoicesValid) return null;

    const bodyLength = length.tapeLength / 2 + 14;
    let hammock = bodyLength * fabric.width / 1296 * fabric.density * layerCount;
    hammock += nettingWeight(length, netting, zipper);
    hammock += zipper.zipper;
    if (!suspension.includesLoops) hammock += loopWeight;
    hammock += length[ridgelineKey];
    hammock += deltaFor('Knee & Shoulder Tie Outs', choice['Knee & Shoulder Tie Outs']);
    hammock += deltaFor('Under Quilt Hooks', choice['Under Quilt Hooks']);
    hammock += deltaFor('Peak Shelf', choice['Peak Shelf']);
    hammock += deltaFor('Bivy Mode Tie Outs', choice['Bivy Mode Tie Outs']);
    hammock += deltaFor('Ridgeline Gear Pouch', choice['Ridgeline Gear Pouch']);
    hammock += deltaFor('Zippered Storage Pouch', choice['Zippered Storage Pouch']);

    const withSuspension = hammock + suspension.weight;
    const packed = withSuspension +
      mainSackWeight(fabric, layerCount, choice['Zipper Size']) +
      CONTROLS.netSack +
      suspension.sack +
      stuffSackUpgrade;

    return { hammock, withSuspension, packed };
  }

  function start() {
    const root = document.querySelector('[data-sld-trail-lair-estimator]');
    if (!root) return;
    const scope = root.closest('product-info') || document;

    function calculate() {
      const choice = selections(scope);
      const result = estimate(choice);
      const results = root.querySelector('[data-sld-estimator-results]');
      const message = root.querySelector('[data-sld-estimator-message]');

      if (choice['Fabric/Color'] === 'Custom (Please Contact Me First)') {
        if (results) results.hidden = true;
        if (message) message.textContent = 'Custom fabrics require a manual weight estimate. Please contact me before ordering.';
        return;
      }

      if (!result) {
        if (results) results.hidden = true;
        if (message) message.textContent = 'Select the hammock options above to see the estimated weight.';
        return;
      }

      const set = (selector, value) => {
        const element = root.querySelector(selector);
        if (element) element.textContent = value.toFixed(1) + ' oz';
      };
      set('[data-sld-weight-hammock]', result.hammock);
      set('[data-sld-weight-suspension]', result.withSuspension);
      set('[data-sld-weight-packed]', result.packed);
      if (results) results.hidden = false;
      if (message) message.textContent = '';
    }

    let timer;
    const queue = () => {
      clearTimeout(timer);
      timer = setTimeout(calculate, 75);
    };
    document.addEventListener('change', queue, true);
    document.addEventListener('input', queue, true);
    document.addEventListener('click', queue, true);
    new MutationObserver(queue).observe(scope, {
      subtree: true,
      attributes: true,
      attributeFilter: ['value', 'checked', 'selected', 'class', 'aria-checked'],
      childList: true
    });
    calculate();
  }

  return { deltaFor, estimate, selections, start };
});
